import { render, staticRenderFns } from "./SharingTab.vue?vue&type=template&id=61dd3373&scoped=true&"
import script from "./SharingTab.vue?vue&type=script&lang=js&"
export * from "./SharingTab.vue?vue&type=script&lang=js&"
import style0 from "./SharingTab.vue?vue&type=style&index=0&id=61dd3373&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dd3373",
  null
  
)

export default component.exports